export default __webpack_public_path__ + "static/media/bkg.42d8135c.jpg";